import apiService from 'apiService';

 const GetProfilDinas = async () => {
    const res = await apiService.get('/standalone/profiles');
    if (res.code === 200) {
      return res.data
    } 
    
  }
export default GetProfilDinas